import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, DatePicker, Button, message } from 'antd'
import moment from 'moment'
import { clickDownload, round } from '../../util/index'
import { salaryRecordList } from '../../api/employee'
const { RangePicker } = DatePicker
import './index.css'

const nowDate = new Date()
nowDate.setMonth(nowDate.getMonth() - 1)
nowDate.setDate(1)
nowDate.setHours(0, 0, 0, 0)
const nextDate = new Date()
nextDate.setMonth(nowDate.getMonth() + 1, 0)
nextDate.setHours(0, 0, 0, 0)
class ClubSalaryStatistics extends Component {
  state = {
    isloading: false,
    pickerValue: [
      moment(nowDate, 'YYYY-MM-DD'),
      moment(nextDate, 'YYYY-MM-DD'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.startOf('day')
    eTime.add(1, 'day')
    eTime.startOf('date')
    const { status, detail, data } = await salaryRecordList({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({
      isloading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const filterAry = dataAry.filter((item) => item.salaryRecord != null)
      const newData = filterAry.map((item) => {
        const { employee, salaryRecord } = item
        return {
          employeeId: employee.id, // 员工id
          name: employee.name,
          salaryId: salaryRecord.id, // 考勤记录ID
          amount: round(salaryRecord.amount / 100, 2), //基础月薪
          tutorCommission: round(salaryRecord.tutorCommission / 100, 2), //助教提成
          scorerCommission: round(salaryRecord.scorerCommission / 100, 2), //记分提成
          commoditySellingCommission: round(
            salaryRecord.commoditySellingCommission / 100,
            2
          ), //销售提成
          attendanceBonus: round(salaryRecord.attendanceBonus / 100, 2), //全勤奖励
          extraWork: round(salaryRecord.extraWork / 100, 2), //加班加薪
          beLate:
            round(salaryRecord.beLate / 100, 2) > 0
              ? `-${round(salaryRecord.beLate / 100, 2)}`
              : 0, //迟到减薪
          leaveEarly:
            round(salaryRecord.leaveEarly / 100, 2) > 0
              ? `-${round(salaryRecord.leaveEarly / 100, 2)}`
              : 0, //早退减薪
          locateException:
            round(salaryRecord.locateException / 100, 2) > 0
              ? `-${round(salaryRecord.locateException / 100, 2)}`
              : 0, //地址异常打卡减薪
          absenteeism:
            round(salaryRecord.absenteeism / 100, 2) > 0
              ? `-${round(salaryRecord.absenteeism / 100, 2)}`
              : 0, //缺勤减薪
          exceedHoliday:
            round(salaryRecord.exceedHoliday / 100, 2) > 0
              ? `-${round(salaryRecord.exceedHoliday / 100, 2)}`
              : 0, //超出月假天数减薪
          agentTax:
            round(salaryRecord.agentTax / 100, 2) > 0
              ? `-${round(salaryRecord.agentTax / 100, 2)}`
              : 0, //代缴税费
          agentSocialSecurity:
            round(salaryRecord.agentSocialSecurity / 100, 2) > 0
              ? `-${round(salaryRecord.agentSocialSecurity / 100, 2)}`
              : 0, //代缴社保费
          meal:
            round(salaryRecord.meal / 100, 2) > 0
              ? `-${round(salaryRecord.meal / 100, 2)}`
              : 0, //餐费
          otherIncrease: round(salaryRecord.otherIncrease / 100, 2), //其它加薪
          otherDecrease:
            round(salaryRecord.otherDecrease / 100, 2) > 0
              ? `-${round(salaryRecord.otherDecrease / 100, 2)}`
              : 0, //其它减薪
          total: round(salaryRecord.total / 100, 2), //薪酬总计
          startTime: moment(salaryRecord.startTime).format('YYYY-MM-DD'),
        }
      })
      this.setState({
        list: newData,
      })
    } else {
      this.setState({
        list: [],
      })
    }
  }

  onChange = (value, dateString) => {
    if (!value) {
      return
    }
    this.setState({
      pickerValue: value,
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({
        dates: [],
        hackValue: [],
      })
    } else {
      this.setState({
        hackValue: undefined,
      })
    }
  }

  onCalendarChange = (val) => {
    this.setState({
      dates: val,
    })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    // 控制选择范围在30天内
    const tooLate =
      this.state.dates[0] && current.diff(this.state.dates[0], 'days') > 30
    const tooEarly =
      this.state.dates[0] && this.state.dates[0].diff(current, 'days') > 30
    return tooLate || tooEarly || current >= moment()
  }
  onSearchEvent = () => {
    if (this.state.isloading) {
      return
    }
    this.setState({ isloading: true }, this.getDatas)
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const dateString = pickerValue
      ? `${pickerValue[0].format('YYYY-MM-DD')}-${pickerValue[1].format(
          'YYYY-MM-DD'
        )}`
      : moment().format('YYYY-MM-DD')
    const columns = [
      {
        title: '日期',
        dataIndex: 'startTime',
        fixed: 'left',
        width: 120,
      },
      {
        title: '员工',
        dataIndex: 'name',
        width: 120,
      },
      {
        title: '基础月薪',
        dataIndex: 'amount',
        width: 120,
      },
      {
        title: '助教提成',
        dataIndex: 'tutorCommission',
        width: 120,
      },
      {
        title: '记分提成',
        dataIndex: 'scorerCommission',
        width: 120,
      },
      {
        title: '销售提成',
        dataIndex: 'commoditySellingCommission',
        width: 120,
      },
      {
        title: '全勤奖励',
        dataIndex: 'attendanceBonus',
        width: 120,
      },
      {
        title: '加班加薪',
        dataIndex: 'extraWork',
        width: 120,
      },
      {
        title: '迟到减薪',
        dataIndex: 'beLate',
        width: 120,
      },
      {
        title: '早退减薪',
        dataIndex: 'leaveEarly',
        width: 120,
      },
      {
        title: '地址异常减薪',
        dataIndex: 'locateException',
        width: 120,
      },
      {
        title: '缺勤减薪',
        dataIndex: 'absenteeism',
        width: 120,
      },
      {
        title: '超出月假天数减薪',
        dataIndex: 'exceedHoliday',
        width: 120,
      },
      {
        title: '代缴税费',
        dataIndex: 'agentTax',
        width: 120,
      },
      {
        title: '代缴社保费',
        dataIndex: 'agentSocialSecurity',
        width: 120,
      },
      {
        title: '餐费',
        dataIndex: 'meal',
        width: 120,
      },
      {
        title: '其他加薪',
        dataIndex: 'otherIncrease',
        width: 120,
      },
      {
        title: '其他减薪',
        dataIndex: 'otherDecrease',
        width: 120,
      },
      {
        title: '合计',
        dataIndex: 'total',
        width: 120,
      },
    ]
    return (
      <div className="salary-statistics-view">
        <div className="css-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="css-button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
          <Button type="default" className="css-button-flex-left">
            <a
              id="test"
              href={clickDownload(columns, list || [])}
              download={`考勤记录按日查看-${dateString}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey="employeeId"
          size="small"
          bordered
          loading={isloading}
          columns={columns}
          dataSource={list}
          scroll={{
            x: columns.length * 120,
          }}
        />
      </div>
    )
  }
}

export default withRouter(ClubSalaryStatistics)



// WEBPACK FOOTER //
// ./src/containers/ClubSalaryStatistics/index.js